export default __webpack_public_path__ + "src/images/system_name/4-ef7896.png";